import { PaletteOptions } from '@mui/material';

interface CustomPalette {
  icon: {
    active: string;
    gray: string;
  };
}

export interface IPaletteOptions extends PaletteOptions {
  custom: CustomPalette;
}

// Использовать только в теме MUI
export const palette: IPaletteOptions = {
  text: {
    primary: 'rgba(0, 0, 0, 0.87)',
  },
  primary: {
    light: '#7099F4',
    main: '#527BCC',
    dark: '#3E67B8',
  },
  background: {
    default: '#f7f7f7',
    paper: '#ffffff',
  },
  custom: {
    icon: {
      active: '#707070',
      gray: '#626262',
    },
  },
};
